import {
  Box,
  Button,
  Flex,
  FormLabel,
  Heading,
  Icon,
  Text,
  Input,
  VStack,
  HStack,
  Image,
} from "@chakra-ui/react";
import { Field, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { BiLowVision, BiShow } from "react-icons/bi";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { FaUser, FaPhone, FaLock, FaBook, FaUsers, FaVenusMars } from "react-icons/fa";
import logo from "../../assets/logo.png"
import {
  signupUserAction,
} from "../../modules/auth/Actions";
import { getAllSubjectsRequest } from "../../modules/admin-modules/subjects/Actions";
import { getUserGroupsRequest } from "../../modules/user/Actions";
import PublicLayout from "../public/Layout/layout";
const SignupForm = (props) => {
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.auth.isLoading);
  const subjects = useSelector((state) => state.subjects.subjects);
  const groups = useSelector((state) => state.user.groups);
  const navigate = useNavigate();
  const [inputType, setInputType] = useState("password");
  const [selectedSubject, setSelectedSubject] = useState(null);

  const subjectsOptions = subjects?.map((data) => {
    return { value: data.id, label: data.name };
  });
  const groupsOptions = groups?.map((data) => {
    return { value: data.id, label: data.name };
  });
  
  const genderOptions = [
    { value: "Male", label: "Male" },
    { value: "Female", label: "Female" }
  ];
  
  const colourStyles = {
    control: (styles) => ({
      ...styles,
      width: "100%",
      background: "white",
      color: "#374151",
      borderRadius: "12px",
      border: "2px solid #E5E7EB",
      boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
      "&:hover": {
        borderColor: "#FF8C00",
      },
      "&:focus": {
        borderColor: "#FF8C00",
        boxShadow: "0 0 0 3px rgba(255, 140, 0, 0.1)",
      },
    }),
    option: (styles, { isFocused, isSelected }) => ({
      ...styles,
      color: isSelected ? "white" : "#374151",
      backgroundColor: isSelected ? "#FF8C00" : isFocused ? "#FFF3E0" : "white",
      "&:hover": {
        backgroundColor: isSelected ? "#FF8C00" : "#FFF3E0",
      },
    }),
    placeholder: (styles) => ({
      ...styles,
      color: "#9CA3AF",
    }),
  };
  
  useEffect(() => {
    dispatch(getAllSubjectsRequest());
  }, []);

  useEffect(() => {
    dispatch(getUserGroupsRequest(selectedSubject));
  }, [selectedSubject]);

  const validateUserName = (value) => {
    let error;
    if (!value) {
      error = "Required";
    }
    return error;
  };
  const validatePhone = (value) => {
    let error;
    if (!value) {
      error = "Required";
    }
    return error;
  };
  const validatePassword = (value) => {
    let error;
    if (!value) {
      error = "Required";
    }

    return error;
  };

  const validateConfirmPassword = (value) => {
    let error;
    if (!value) {
      error = "Required";
    }
    return error;
  };
  
  const validateParentPhone = (value) => {
    let error;
    if (!value) {
      error = "Required";
    }
    return error;
  };
  
  const validateSubjectId = (value) => {
    let error;
    if (!value) {
      error = "Required";
    }
    return error;
  };
  
  const validateStudentGroupId = (value) => {
    let error;
    if (!value) {
      error = "Required";
    }
    return error;
  };
  
  const validateGender = (value) => {
    let error;
    if (!value) {
      error = "Required";
    }
    return error;
  };
  return (
    <PublicLayout color="main_1" bg="white" register={false}>
      <Flex
        flexDirection="column"
        alignItems="center"
        my="50px"
        w="100%"
        h="100%"
        minH="100vh"
        bg="#FFFEF7"
        py={8}
      >
        <Formik
          initialValues={{
            name: "",
            phone: "",
            password: "",
            faculty_id: "",
            year_id: "",
            profile_url: "",
            profile_url2: "",
            parent_phone: "",
            subject_id: "",
            student_group_id: "",
            gender: "",
            terms: false,
          }}
          onSubmit={(values) => {
            let formData = new FormData();
            formData.append("name", values.name);
            formData.append("phone", values.phone);
            formData.append("password", values.password);
            formData.append(
              "password_confirmation",
              values.password_confirmation
            );
            formData.append("parent_phone", values.parent_phone);
            formData.append("subject_id", values.subject_id);
            formData.append("student_group_id", values.student_group_id);
            formData.append("gender", values.gender);

            dispatch(
              signupUserAction(formData, () => {
                navigate("/login");
              })
            );
            
          }}
        >
          {({ setValues, errors, touched, values, setFieldValue }) => (
            <Form
              style={{
                width: "100%",
                margin: "auto",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Box
                bg="white"
                borderRadius="24px"
                boxShadow="0 20px 40px rgba(0,0,0,0.1)"
                p={8}
                w={{ base: "95%", md: "800px" }}
                maxW="800px"
              >
                <VStack spacing={8} align="stretch">
                  <VStack spacing={4} align="center">
                    <Image
                      src={logo}
                      alt="logo"
                      w="120px"
                      h="auto"
                    />
                    <Heading 
                      textAlign="center" 
                      fontSize={{ base: "28px", md: "32px" }}
                      fontWeight="800"
                      color="gray.800"
                      fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif"
                    >
                      إنشاء حساب جديد
                    </Heading>
                    <Text 
                      textAlign="center" 
                      color="gray.600"
                      fontSize="16px"
                      fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif"
                    >
                      املأ البيانات التالية لإنشاء حسابك
                    </Text>
                  </VStack>

                  {/* Name Field */}
                  <Box w="100%">
                    <FormLabel
                      htmlFor="name"
                      color="gray.700"
                      fontSize="16px"
                      fontWeight="700"
                      mb={3}
                      fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif"
                    >
                      <HStack spacing={2}>
                        <FaUser color="#FF8C00" />
                        <Text>الاسم الكامل</Text>
                      </HStack>
                    </FormLabel>

                    <Field
                      as={Input}
                      name="name"
                      validate={validateUserName}
                      placeholder="أدخل اسمك الكامل"
                      size="lg"
                      borderRadius="xl"
                      border="2px"
                      borderColor="gray.200"
                      bg="white"
                      _focus={{
                        borderColor: 'orange.500',
                        boxShadow: '0 0 0 3px rgba(255, 140, 0, 0.1)',
                      }}
                      _hover={{
                        borderColor: 'orange.300',
                      }}
                      fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif"
                    />
                    {errors.name && touched.name && (
                      <Text color="red.500" fontSize="sm" mt={2} fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif">
                        {errors.name}
                      </Text>
                    )}
                  </Box>

                  {/* Phone Fields Row */}
                  <Flex w="100%" gap={6} flexDirection={{ base: "column", md: "row" }}>
                    <Box w={{ base: "100%", md: "50%" }}>
                      <FormLabel
                        htmlFor="phone"
                        color="gray.700"
                        fontSize="16px"
                        fontWeight="700"
                        mb={3}
                        fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif"
                      >
                        <HStack spacing={2}>
                          <FaPhone color="#FF8C00" />
                          <Text>رقم الهاتف</Text>
                        </HStack>
                      </FormLabel>
                      <Text 
                        fontSize="12px" 
                        color="gray.500" 
                        mb={3}
                        fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif"
                      >
                        يرجي إضافة 00 قبل إضافة الأرقام الخليجية مثال 009xxxx في حالة الرقم المصري يرجى كتابة الرقم بالكامل دون إضافات مثال 012345
                      </Text>

                      <Field
                        as={Input}
                        name="phone"
                        type="text"
                        validate={validatePhone}
                        placeholder="أدخل رقم هاتفك"
                        size="lg"
                        borderRadius="xl"
                        border="2px"
                        borderColor="gray.200"
                        bg="white"
                        _focus={{
                          borderColor: 'orange.500',
                          boxShadow: '0 0 0 3px rgba(255, 140, 0, 0.1)',
                        }}
                        _hover={{
                          borderColor: 'orange.300',
                        }}
                        fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif"
                      />
                      {errors.phone && touched.phone && (
                        <Text color="red.500" fontSize="sm" mt={2} fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif">
                          {errors.phone}
                        </Text>
                      )}
                    </Box>

                    <Box w={{ base: "100%", md: "50%" }}>
                      <FormLabel
                        htmlFor="parent_phone"
                        color="gray.700"
                        fontSize="16px"
                        fontWeight="700"
                        mb={3}
                        fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif"
                      >
                        <HStack spacing={2}>
                          <FaPhone color="#FF8C00" />
                          <Text>رقم هاتف ولي الأمر</Text>
                        </HStack>
                      </FormLabel>
                      <Text 
                        fontSize="12px" 
                        color="gray.500" 
                        mb={3}
                        fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif"
                      >
                        يرجي إضافة 00 قبل إضافة الأرقام الخليجية مثال 009xxxx في حالة الرقم المصري يرجى كتابة الرقم بالكامل دون إضافات مثال 012345
                      </Text>

                      <Field
                        as={Input}
                        name="parent_phone"
                        type="text"
                        validate={validateParentPhone}
                        placeholder="أدخل رقم هاتف ولي الأمر"
                        size="lg"
                        borderRadius="xl"
                        border="2px"
                        borderColor="gray.200"
                        bg="white"
                        _focus={{
                          borderColor: 'orange.500',
                          boxShadow: '0 0 0 3px rgba(255, 140, 0, 0.1)',
                        }}
                        _hover={{
                          borderColor: 'orange.300',
                        }}
                        fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif"
                      />
                      {errors.parent_phone && touched.parent_phone && (
                        <Text color="red.500" fontSize="sm" mt={2} fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif">
                          {errors.parent_phone}
                        </Text>
                      )}
                    </Box>
                  </Flex>

                  {/* Password Fields Row */}
                  <Flex w="100%" gap={6} flexDirection={{ base: "column", md: "row" }}>
                    <Box w={{ base: "100%", md: "50%" }} position="relative">
                      <FormLabel
                        htmlFor="password"
                        color="gray.700"
                        fontSize="16px"
                        fontWeight="700"
                        mb={3}
                        fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif"
                      >
                        <HStack spacing={2}>
                          <FaLock color="#FF8C00" />
                          <Text>كلمة المرور</Text>
                        </HStack>
                      </FormLabel>

                      <Field
                        as={Input}
                        name="password"
                        validate={validatePassword}
                        type={inputType}
                        placeholder="أدخل كلمة المرور"
                        size="lg"
                        borderRadius="xl"
                        border="2px"
                        borderColor="gray.200"
                        bg="white"
                        pr="50px"
                        _focus={{
                          borderColor: 'orange.500',
                          boxShadow: '0 0 0 3px rgba(255, 140, 0, 0.1)',
                        }}
                        _hover={{
                          borderColor: 'orange.300',
                        }}
                        fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif"
                      />

                      <Icon
                        position="absolute"
                        right="15px"
                        top="50px"
                        fontSize="20px"
                        color="gray.500"
                        cursor="pointer"
                        _hover={{ color: "orange.500" }}
                        as={inputType === "password" ? BiShow : BiLowVision}
                        onClick={() =>
                          inputType === "password"
                            ? setInputType("text")
                            : setInputType("password")
                        }
                      />
                      {errors.password && touched.password && (
                        <Text color="red.500" fontSize="sm" mt={2} fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif">
                          {errors.password}
                        </Text>
                      )}
                    </Box>

                    <Box w={{ base: "100%", md: "50%" }} position="relative">
                      <FormLabel
                        htmlFor="password_confirmation"
                        color="gray.700"
                        fontSize="16px"
                        fontWeight="700"
                        mb={3}
                        fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif"
                      >
                        <HStack spacing={2}>
                          <FaLock color="#FF8C00" />
                          <Text>تأكيد كلمة المرور</Text>
                        </HStack>
                      </FormLabel>

                      <Field
                        as={Input}
                        name="password_confirmation"
                        validate={validateConfirmPassword}
                        type={inputType}
                        placeholder="أعد إدخال كلمة المرور"
                        size="lg"
                        borderRadius="xl"
                        border="2px"
                        borderColor="gray.200"
                        bg="white"
                        pr="50px"
                        _focus={{
                          borderColor: 'orange.500',
                          boxShadow: '0 0 0 3px rgba(255, 140, 0, 0.1)',
                        }}
                        _hover={{
                          borderColor: 'orange.300',
                        }}
                        fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif"
                      />

                      <Icon
                        position="absolute"
                        right="15px"
                        top="50px"
                        fontSize="20px"
                        color="gray.500"
                        cursor="pointer"
                        _hover={{ color: "orange.500" }}
                        as={inputType === "password" ? BiShow : BiLowVision}
                        onClick={() =>
                          inputType === "password"
                            ? setInputType("text")
                            : setInputType("password")
                        }
                      />
                      {errors.password_confirmation && touched.password_confirmation && (
                        <Text color="red.500" fontSize="sm" mt={2} fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif">
                          {errors.password_confirmation}
                        </Text>
                      )}
                    </Box>
                  </Flex>


                  {/* Subject and Group Fields Row */}
                  <Flex w="100%" gap={6} flexDirection={{ base: "column", md: "row" }}>
                    <Box w={{ base: "100%", md: "50%" }}>
                      <FormLabel
                        htmlFor="subject_id"
                        color="gray.700"
                        fontSize="16px"
                        fontWeight="700"
                        mb={3}
                        fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif"
                      >
                        <HStack spacing={2}>
                          <FaBook color="#FF8C00" />
                          <Text>المادة الدراسية</Text>
                        </HStack>
                      </FormLabel>

                      <Select
                        options={subjectsOptions}
                        onChange={(data) => {
                          setFieldValue("subject_id", data.value);
                          setSelectedSubject(data.value);
                        }}
                        styles={colourStyles}
                        placeholder="اختر المادة الدراسية"
                        validate={validateSubjectId}
                      />
                      {errors.subject_id && touched.subject_id && (
                        <Text color="red.500" fontSize="sm" mt={2} fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif">
                          {errors.subject_id}
                        </Text>
                      )}
                    </Box>

                    <Box w={{ base: "100%", md: "50%" }}>
                      <FormLabel
                        htmlFor="student_group_id"
                        color="gray.700"
                        fontSize="16px"
                        fontWeight="700"
                        mb={3}
                        fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif"
                      >
                        <HStack spacing={2}>
                          <FaUsers color="#FF8C00" />
                          <Text>المجموعة الدراسية</Text>
                        </HStack>
                      </FormLabel>

                      <Select
                        options={groupsOptions}
                        onChange={(data) => {
                          setFieldValue("student_group_id", data.value);
                        }}
                        styles={colourStyles}
                        placeholder="اختر المجموعة الدراسية"
                        validate={validateStudentGroupId}
                      />
                      {errors.student_group_id && touched.student_group_id && (
                        <Text color="red.500" fontSize="sm" mt={2} fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif">
                          {errors.student_group_id}
                        </Text>
                      )}
                    </Box>
                  </Flex>

                  {/* Gender Field */}
                  <Box w="100%">
                    <FormLabel
                      htmlFor="gender"
                      color="gray.700"
                      fontSize="16px"
                      fontWeight="700"
                      mb={3}
                      fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif"
                    >
                      <HStack spacing={2}>
                        <FaVenusMars color="#FF8C00" />
                        <Text>النوع</Text>
                      </HStack>
                    </FormLabel>

                    <Select
                      options={genderOptions}
                      onChange={(data) => {
                        setFieldValue("gender", data.value);
                      }}
                      styles={colourStyles}
                      placeholder="اختر النوع"
                      validate={validateGender}
                    />
                    {errors.gender && touched.gender && (
                      <Text color="red.500" fontSize="sm" mt={2} fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif">
                        {errors.gender}
                      </Text>
                    )}
                  </Box>

                  {/* Submit Button */}
                  <Button
                    type="submit"
                    w="full"
                    p="20px"
                    alignSelf="center"
                    isLoading={isLoading}
                    bg="orange.500"
                    color="white"
                    borderRadius="xl"
                    fontSize="18px"
                    fontWeight="700"
                    _hover={{
                      bg: "orange.600",
                      transform: "translateY(-2px)",
                      boxShadow: "0 8px 25px rgba(255, 140, 0, 0.3)"
                    }}
                    _active={{ transform: "translateY(0)" }}
                    transition="all 0.3s ease"
                    boxShadow="0 4px 15px rgba(255, 140, 0, 0.2)"
                    fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif"
                  >
                    إنشاء الحساب
                  </Button>

                  {/* Login Link */}
                  <Text 
                    textAlign="center" 
                    mt={6}
                    fontSize="16px"
                    color="gray.600"
                    fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif"
                  >
                    لديك حساب بالفعل؟{" "}
                    <a
                      href="/circles/login"
                      style={{ 
                        color: "#FF8C00", 
                        textDecoration: "underline",
                        fontWeight: "700"
                      }}
                    >
                      تسجيل الدخول
                    </a>
                  </Text>
                </VStack>
              </Box>
            </Form>
          )}
        </Formik>
      </Flex>
    </PublicLayout>
  );
};

export default SignupForm;
